export default __webpack_public_path__ + "static/media/timescaledb-dark.041c50c6.jpeg";